import { forwardRef } from "react";

import {
  BADGE_DEFAULTS,
  BADGE_VARIANT_CLASS_MAP,
  type TBadgeProps,
} from "@/ui/components/primitives/Badge/Badge.config";
import { cn } from "@/ui/lib/utils";
import { TextControl } from "../../typography/TextControl";
import { Icon } from "../Icon";

export const Badge = forwardRef<HTMLDivElement, TBadgeProps>(
  (
    {
      className,
      variant = BADGE_DEFAULTS.variant,
      children,
      icon,
      ...props
    },
    ref,
  ) => (
    <div
      {...props}
      ref={ref}
      data-component="Badge"
      className={cn(
        "inline-flex gap-1 justify-center items-center border p-1 w-fit",
        "-rotate-2",
        BADGE_VARIANT_CLASS_MAP[variant],
        className,
      )}
    >
      { icon ? (
        <Icon icon={icon} aria-hidden="true" size="sm" />
      ): null }
      <TextControl size={2} isResponsive={false}>{ children }</TextControl>
    </div>
  ),
); Badge.displayName = "Badge";
